import logo from './logo.svg';
import './App.css';
import Routing from '../src/Routing/Routing';
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast"; // ✅ Import this

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routing />
      </BrowserRouter>

      {/* ✅ Add Toaster here so toast messages can appear */}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#fff",
            color: "#333",
            fontSize: "14px",
            fontWeight: "500"
          },
          success: { style: { background: "white", color: "#2e7d32" } },
          error: { style: { background: "white", color: "#d32f2f" } },
        }}
      />
    </div>
  );
};

export default App;
